export default __webpack_public_path__ + "static/media/lyin.ce4bedbc.jpg";